var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rs-list-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.7808 5.92741L1.6665 4.84071L2.66058 3.87124L3.77559 4.95795C3.90942 5.08275 4.08745 5.1524 4.27263 5.1524C4.4578 5.1524 4.63583 5.08275 4.76967 4.95795L7.29072 2.5L8.2848 3.46947L5.76375 5.92741C5.5679 6.11845 5.33538 6.26999 5.07947 6.37337C4.82356 6.47676 4.54927 6.52998 4.27227 6.52998C3.99528 6.52998 3.72099 6.47676 3.46508 6.37337C3.20917 6.26999 2.97665 6.11845 2.7808 5.92741ZM9.89684 5.84445H18.3332V4.47321H9.89684V5.84445ZM4.27263 12.015C4.5497 12.0158 4.82417 11.9629 5.08013 11.8595C5.3361 11.756 5.56846 11.6041 5.76375 11.4124L8.2848 8.95443L7.29072 7.98496L4.76967 10.4429C4.63583 10.5677 4.4578 10.6374 4.27263 10.6374C4.08745 10.6374 3.90942 10.5677 3.77559 10.4429L2.66058 9.3562L1.6665 10.3257L2.7808 11.4124C2.97627 11.604 3.20876 11.756 3.46483 11.8594C3.7209 11.9628 3.99546 12.0157 4.27263 12.015ZM9.89684 11.3294H18.3332V9.95817H9.89684V11.3294ZM4.27263 17.5C4.5497 17.5008 4.82417 17.4479 5.08013 17.3444C5.3361 17.241 5.56846 17.089 5.76375 16.8973L8.2848 14.4394L7.29072 13.4699L4.76967 15.9279C4.63583 16.0527 4.4578 16.1223 4.27263 16.1223C4.08745 16.1223 3.90942 16.0527 3.77559 15.9279L2.66058 14.8412L1.6665 15.8106L2.7808 16.8973C2.97627 17.089 3.20876 17.2409 3.46483 17.3444C3.7209 17.4478 3.99546 17.5007 4.27263 17.5ZM9.89684 16.8144H18.3332V15.4431H9.89684V16.8144Z",
    fill: "#57689F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskType);
export default __webpack_public_path__ + "static/media/taskType.3347e27273b78b29c883c85642dc109f.svg";
export { ForwardRef as ReactComponent };